import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { formatCurrency } from "utils/tools"

export interface ExpenseBudgetVendorChartPoint {
    vendor: string
    planned: number
    billed: number
}

interface ExpenseBudgetVendorChartProps {
    data: ExpenseBudgetVendorChartPoint[]
}

const ROW_HEIGHT = 48

// Planned spend for the year vs Acumatica bills linked so far, per vendor, largest plan first.
const ExpenseBudgetVendorChart = ({ data }: ExpenseBudgetVendorChartProps) => (
    <div style={{ width: "100%", height: Math.max(180, data.length * ROW_HEIGHT + 70) }}>
        <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical" margin={{ right: 20, left: 10, bottom: 10 }} barGap={2}>
                <CartesianGrid strokeDasharray="3 3" horizontal={false} />
                <XAxis type="number" tickFormatter={(v: number) => formatCurrency(v, "CAD", 0)} />
                <YAxis type="category" dataKey="vendor" width={160} />
                <Tooltip formatter={(v: number) => formatCurrency(v)} />
                <Legend />
                <Bar dataKey="planned" name="Plan" fill="var(--bs-primary)" radius={[0, 4, 4, 0]} barSize={14} />
                <Bar dataKey="billed" name="Billed (linked)" fill="var(--bs-warning)" radius={[0, 4, 4, 0]} barSize={14} />
            </BarChart>
        </ResponsiveContainer>
    </div>
)

export default ExpenseBudgetVendorChart
